import _ from 'lodash';
import hash from 'object-hash';

// Import Actions
import {
  UPDATE_PAGE_NAME,
  LOADING_DATA,
  DASHBOARD_DATA,
  DASHBOARD_ANALYSIS_DATA,
  FIELD_DATA,
  SET_OUTSIDE,
  SET_APP,
  SET_WALLMODE,
  NAV_SHOWN,
  NAV_EXPANDED,
  NAV_OPENED,
  OVERVIEW_LOADING,
  LAST_UPDATED,
  PROGRESS,
  ANALYSIS_LOADING,
} from './AppActions';

// Initial State
const initialState = {
  pageName: 'Dashboard',
  data: {},
  analysisData: {},
  dataHash: '',
  isLoading: false,
  overviewLoading: false,
  analysisLoading: false,
  outside: false,
  plugin: {},
  app: 'trello',
  appName: 'Trello',
  wallmode: false,
  navigationShown: false,
  navigationExpanded: ['flow-metrics', 'executive'],
  navigationMenuOpened: false,
  lastUpdated: undefined,
  progress: '',
};

function makeid(length) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

const AppReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROGRESS:
      return {
        ...state,
        progress: action.progress,
      };
    case UPDATE_PAGE_NAME:
      return {
        ...state,
        pageName: action.pageName,
      };

    case LOADING_DATA:
      return {
        ...state,
        isLoading: action.isLoading,
        progress: '',
      };

    case LAST_UPDATED:
      return {
        ...state,
        lastUpdated: action.date,
      };

    case DASHBOARD_DATA:
      let filtersDataHash;
      if (action.fieldType) {
        filtersDataHash = hash.MD5(state.data[action.fieldType]);
      }

      return {
        ...state,
        data: action.data,
        dataHash: makeid(10),
        filtersDataHash,
        updatedField: action.fieldType,
        isLoading: false,
        progress: '',
      };
    case DASHBOARD_ANALYSIS_DATA:
        return {
          ...state,
          analysisData: action.data,
          analysisDataHash: makeid(10),
          filtersDataHash,
          updatedField: action.fieldType,
          analysisLoading: false,
          progress: '',
        };  

    case FIELD_DATA:
      const prevData = state.data;
      const update = state.data;

      if (action.field === 'labels') {
        update.labels = action.data;
      } else {
        const index = _.findIndex(update.customFields, { _id: action.field });
        if (index > -1) {
          const options = _.unionBy([...update.customFields[index].options, ...action.data], '_id');
          update.customFields[index].options = options;
        }
      }

      return {
        ...state,
        data: {
          ...prevData,
          ...update,
        },
      };

    case SET_OUTSIDE:
      return {
        ...state,
        plugin: action.plugin,
        outside: true,
      };

    case SET_APP:
      return {
        ...state,
        app: action.app,
        appName: action.appName,
      };

    case SET_WALLMODE:
      return {
        ...state,
        wallmode: action.value,
      };

    case NAV_SHOWN:
      return {
        ...state,
        navigationShown: action.navigationShown,
      };
    case NAV_EXPANDED:
      return {
        ...state,
        navigationExpanded: action.navigationExpanded,
      };
    case NAV_OPENED:
      return {
        ...state,
        navigationMenuOpened: action.navigationMenuOpened,
      };
    case OVERVIEW_LOADING:
      return {
        ...state,
        overviewLoading: action.overviewLoading,
      };
    case ANALYSIS_LOADING:
      return {
        ...state,
        analysisLoading: action.analysisLoading,
      };        
    default:
      return state;
  }
};

// Export Reducer
export default AppReducer;
